module.exports = __webpack_public_path__ + "img/newchris-14.2ad86a6e.jpg";